import { humanizeDate } from '@/utils'
import type { SupportMessage } from '../types'

export const TicketStatusEvent = ({ message }: { message: SupportMessage }) => (
  <div className="flex items-center justify-center gap-3 py-1">
    <span className="h-px w-8 shrink-0 bg-blue-2" />
    <span className="text-center text-xs text-ink-subtle text-pretty">
      {message.body} · {humanizeDate(message.createdAt)}
    </span>
    <span className="h-px w-8 shrink-0 bg-blue-2" />
  </div>
)
